import React, { useEffect, useRef } from "react";
import { ChatProductCard, parseCartTags } from "@/components/chat/ChatProductCard";

const AiMessage = ({ m, streaming, products, avatar }) => {
  const { text, skus } = parseCartTags(m.text);
  const cards = streaming ? [] : skus.map((s) => products?.find((p) => p.sku === s)).filter((p) => p && p.status === "available");
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-end gap-2">
        <img src={avatar} alt="" className="w-6 h-6 rounded-full object-cover flex-shrink-0 mb-1" style={{ border: "1.5px solid var(--sun-orange)" }} />
        <div className="chat-bubble ai">{text || (streaming ? "…" : "")}</div>
      </div>
      {cards.length > 0 && (
        <div className="flex flex-col gap-2 pl-8">
          {cards.map((p) => <ChatProductCard key={p.sku} product={p} />)}
        </div>
      )}
    </div>
  );
};

export const ChatMessages = ({ messages, sending, avatar, products }) => {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages, sending]);

  return (
    <div ref={scrollRef} className="flex-1 overflow-y-auto p-4 flex flex-col gap-3" style={{ background: "var(--bg)" }}>
      {messages.map((m, i) =>
        m.role === "user" ? (
          <div key={m.id} className="flex items-end gap-2 justify-end">
            <div className="chat-bubble user">{m.text}</div>
          </div>
        ) : (
          <AiMessage key={m.id} m={m} streaming={sending && i === messages.length - 1} products={products} avatar={avatar} />
        )
      )}
    </div>
  );
};
